<div class='px-[24px] py-[16px] max-w-[640px] w-full'>
  <ng-content></ng-content>
</div>
